// features/intelligence/components/practitioner-lens.js
// ═══════════════════════════════════════════════════════════
// PRACTITIONER LENS — collapse bar + body + pathway buttons
// The differentiator. Every Dashboard section ends with this:
// a thin row that expands into user-specific interpretation
// of what the data above means for THIS user's setup.
//
// Three pathway buttons (kept generic so any section can pick
// which to show): Understand · Ask · Apply. Wired up to
// callbacks the parent feature provides — no DOM globals.
// ═══════════════════════════════════════════════════════════

import { useState } from 'react';

export default function PractitionerLens({ lens, onPathway }) {
  const [open, setOpen] = useState(false);
  if (!lens) return null;

  const pathways = lens.pathways || ['understand', 'ask', 'apply'];
  const labels = lens.pathwayLabels || {};

  return (
    <>
      <button
        type="button"
        className="di-lens-bar"
        onClick={() => setOpen(o => !o)}
      >
        {/* The lens dot is rendered via CSS .di-lens-icon as a small
            gold pulse — no glyph needed in markup. */}
        <span className="di-lens-icon" aria-hidden="true" />
        <span className="di-lens-label">Practitioner Lens</span>
        <span className="di-lens-preview">{lens.preview}</span>
        <span className={`di-lens-chev${open ? ' open' : ''}`}>▾</span>
      </button>
      {open && (
        <div className="di-lens-body">
          {lens.eyebrow && <div className="di-lens-eyebrow">{lens.eyebrow}</div>}
          <div
            className="di-lens-text"
            dangerouslySetInnerHTML={{ __html: lens.body }}
          />
          {pathways.length > 0 && (
            <div className="di-pathways">
              {pathways.map(p => (
                <button
                  key={p}
                  type="button"
                  className={`di-pw ${p}`}
                  onClick={() => onPathway?.(p, lens)}
                >
                  {labels[p] || p}
                </button>
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
}
